import MicroModal from 'micromodal';  // es6 module

MicroModal.init();

document.addEventListener("DOMContentLoaded", function() {
    const mapImage = document.querySelector(".map__image");
    if (!mapImage) return;

    const openStateModal = function(stateId) {
      if (!stateId) return;

      const modalId = "modal-" + stateId.toUpperCase();
      if (!document.getElementById(modalId)) {
        console.warn("Missing modal for state:", stateId);
        return;
      }

      console.log("Clicked state:", stateId);
      MicroModal.show(modalId);
    };

    // Inline SVG (included via PHP) lives in the same DOM, so bind directly.
    mapImage.addEventListener("click", function(event) {
      const stateEl = event.target.closest("[id]");
      if (!stateEl) return;
      openStateModal(stateEl.getAttribute("id"));
    });


    document.querySelectorAll(".map__state").forEach((state) => {
        state.addEventListener("click", function() {
            openStateModal(this.getAttribute("id"));
        });
    });
  
  });